import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeftRight, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

let BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (BACKEND_URL && !BACKEND_URL.startsWith("http")) {
  BACKEND_URL = `https://${BACKEND_URL}`;
}
if (!BACKEND_URL) {
  BACKEND_URL = window.location.origin;
}
const API = `${BACKEND_URL}/api`;

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Lien de confirmation invalide.");
      return;
    }

    axios
      .post(`${API}/auth/verify-email`, { token })
      .then((res) => {
        setStatus("success");
        setMessage(res.data.message);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Erreur lors de la confirmation.");
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="flex items-center justify-center w-11 h-11 rounded-xl bg-indigo-600">
            <ArrowLeftRight className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-bold text-slate-900 text-xl tracking-tight">Field Sync</h1>
            <p className="text-sm text-slate-500">HubSpot &#8596; Business Central</p>
          </div>
        </div>

        <Card>
          <CardHeader className="text-center">
            <CardTitle>Confirmation du courriel</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            {status === "loading" && (
              <div className="py-8">
                <Loader2 className="w-10 h-10 mx-auto text-indigo-600 animate-spin" />
                <p className="mt-4 text-slate-500">Vérification en cours...</p>
              </div>
            )}

            {status === "success" && (
              <div className="py-8">
                <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-500" />
                <p className="mt-4 text-slate-700">{message}</p>
              </div>
            )}

            {status === "error" && (
              <div className="py-8">
                <XCircle className="w-12 h-12 mx-auto text-red-500" />
                <p className="mt-4 text-slate-700">{message}</p>
              </div>
            )}

            <Link to="/login">
              <Button variant="outline" className="mt-4">
                Retour à la connexion
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
